import { createFileRoute } from '@tanstack/react-router'

import CreateSwadayaPage from '@/components/pages/backoffice/_ktg-penyuluh/swadaya/_create/containers/CreateSwadayaPage'

export const Route = createFileRoute(
  '/_backoffice/ktg-penyuluh/swadaya/create/'
)({
  component: CreateSwadayaPage
})
